import {showErrorMessage} from '@/helper';

export const visibleInvestmentQuestionnaireResultKeys = [
    'CLASSIFICATION',
    //'SKILLS_SCORE',
    //'KNOWLEDGE_SCORE',
    'INVESTMENT_HORIZON',
    'AVAILABILITY_TO_LOSS',
    'INVESTMENT_PREFERENCE',
    'INVESTMENT_TARGET',
    'RISK_TOLERANCE',
    'FINANCIAL_SITUATION',
    'RISK_TOLERANCE_CORRECTION',
    // FKI — zobrazí se pouze pokud dotazník obsahoval FKI sekci (hodnota není null)
    'FKI_SUITABLE',
    'FKI_QUALIFIED_INVESTOR',
    'FKI_REASON',
];

export default {
    fetchRecords(clientId, body) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/investment-questionnaires/list`, {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll() {
        return new Promise((resolve, reject) => {
            http.get('api/investment-questionnaires').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveQuestionnaire(clientId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/clients/' + clientId + '/investment-questionnaires' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error.response.data);
            });
        });
    },

    countResult(clientId, questionnaireId, data) {
        return new Promise((resolve, reject) => {
            http.post(`api/clients/${clientId}/investment-questionnaires${questionnaireId ? '/' + questionnaireId : ''}/evaluate-preview`, data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error.response.data);
            });
        });
    },

    getInvestmentQuestionnaireQuestions() {
        return new Promise((resolve, reject) => {
            http.get('api/investment-questionnaires/questions').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteRecord(clientId, recordId) {
        return new Promise((resolve, reject) => {
            http.delete('api/clients/' + clientId + '/investment-questionnaires/' + recordId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getUsers() {
        return new Promise((resolve, reject) => {
            http.get('api/users').then(response => {
                resolve(response.data.users);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getUser(id) {
        return new Promise((resolve, reject) => {
            http.get('api/users/' + id).then(response => {
                resolve(response.data.user);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },
}
